import * as React from 'react'
import {
  Keyboard,
  KeyboardAvoidingView,
  StyleSheet,
  TextInput,
  View,
} from 'react-native'
import * as Colors from '@themes/Colors'
import Fonts from '@themes/Fonts'
import { defaultShadow } from '@themes/Shadows'

function useAsyncDebounce<T extends (...args: any[]) => any>(
  fn: T,
  wait: number
) {
  const timeoutRef = React.useRef<any>()
  return React.useCallback(
    (...args: Parameters<T>) => {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = setTimeout(() => fn(...args), wait)
    },
    [fn, wait]
  )
}

export type Props = {
  onSearch?: (value: string) => void
  placeholder?: string
}

export function GlobalFilter({ placeholder, onSearch }: Props) {
  const [value, setValue] = React.useState<string>()
  const onChange = useAsyncDebounce((val) => {
    if (onSearch) onSearch(val || undefined)
  }, 200)

  return (
    <View style={styles.header}>
      <KeyboardAvoidingView style={styles.searchContainer}>
        <TextInput
          style={styles.searchBar}
          onChangeText={(text) => {
            setValue(text)
            onChange(text)
          }}
          clearButtonMode="always"
          enablesReturnKeyAutomatically
          onBlur={() => Keyboard.dismiss()}
          onEndEditing={() => Keyboard.dismiss()}
          value={value || ''}
          placeholder={placeholder ? placeholder : ''}
          placeholderTextColor="#A5A5A9"
        />
      </KeyboardAvoidingView>
    </View>
  )
}

const styles = StyleSheet.create({
  header: {
    paddingBottom: 8,
    backgroundColor: Colors.white,
    zIndex: 9999,
    elevation: 9999,
    paddingHorizontal: 16,
  },
  searchContainer: {
    marginVertical: 8,
    paddingRight: 8,
    borderRadius: 20,
    backgroundColor: '#EFEFEF',
  },
  searchBar: {
    borderRadius: 16,
    paddingHorizontal: 16,
    fontSize: 14,
    minHeight: 36,
    fontFamily: Fonts.type.regular,
    color: Colors.realBlack,
  },
})
